import { Card } from "soapbox/components/ui/card.tsx";

const TosPage: React.FC = () => {
  const html = `
<h1>Terms of Service for TrueMaple</h1>

<section>
    <h2>Purpose and Mission</h2>
    <p>TrueMaple is a platform dedicated to promoting free speech without hateful content. We believe in open dialogue, mutual respect, and creating a space where people can come together to share ideas without division. Our goal is to foster meaningful conversations while maintaining a welcoming and inclusive environment for everyone.</p>
</section>

<section>
    <h2>1. Acceptance of Terms</h2>
    <p>By accessing or using TrueMaple, you agree to these Terms of Service. If you do not agree, you may not use the platform.</p>
</section>

<section>
    <h2>2. Account Requirements</h2>
    <ul>
        <li>Users must be at least 13 years old.</li>
        <li>You are responsible for keeping your account secure.</li>
        <li>Accurate information must be provided when creating an account.</li>
    </ul>
</section>

<section>
    <h2>3. Content Guidelines</h2>
    <p>TrueMaple champions free speech. Certain content is not allowed:</p>
    <ul>
        <li><strong>Illegal activity:</strong> Threats, harassment, or content promoting illegal acts.</li>
        <li><strong>Direct threats</strong> of violence or terrorism.</li>
        <li><strong>Child sexual exploitation</strong> or abuse.</li>
        <li><strong>Spam</strong> or malicious software.</li>
        <li><strong>Adult Content:</strong> Pornographic or sexually explicit content is not permitted on TrueMaple.</li>
        <li><strong>External Adult Platforms:</strong> Linking to, promoting, or redirecting users to external adult content platforms (including subscription-based services) is strictly prohibited.</li>
    </ul>
    <p>Content that attempts to circumvent these rules through indirect promotion, branding, or identical account associations will also be subject to enforcement.</p>
</section>

<section>
    <h2>4. Content Usage</h2>
    <p>By posting content on TrueMaple, you grant us the right to:</p>
    <ul>
        <li>Use your content to promote TrueMaple, including in advertisements, social media posts, or marketing materials.</li>
        <li>Display, reproduce, or modify your content solely for the purpose of promoting the platform.</li>
    </ul>
    <p>You retain ownership of your content, and this license does not grant third parties any rights to your content outside of TrueMaple's promotional use.</p>
</section>

<section>
    <h2>5. Moderation</h2>
    <p>While TrueMaple values free expression, we reserve the right to:</p>
    <ul>
        <li>Remove content that violates Canadian law or these TOS.</li>
        <li>Suspend or terminate accounts that repeatedly violate our rules.</li>
    </ul>
    <p>We aim for transparent moderation and may provide explanations for content removal or account actions.</p>
</section>

<section>
    <h2>6. Intellectual Property</h2>
    <ul>
        <li>You retain ownership of your content.</li>
        <li>By posting, you grant TrueMaple a non-exclusive license to display and distribute your content within the platform and for promotional purposes.</li>
    </ul>
</section>

<section>
    <h2>7. User Conduct</h2>
    <ul>
        <li>Respect other users.</li>
        <li>Do not impersonate others or misrepresent your identity.</li>
        <li>Avoid actions that harm the platform, like hacking or exploiting bugs.</li>
    </ul>
</section>

<section>
    <h2>8. Disclaimers</h2>
    <ul>
        <li>TrueMaple is provided "as is."</li>
        <li>We do not guarantee that content is accurate or free from offensive material.</li>
        <li>Users access the platform at their own risk.</li>
    </ul>
</section>

<section>
    <h2>9. Limitation of Liability</h2>
    <ul>
        <li>TrueMaple is not responsible for user-generated content.</li>
        <li>We are not liable for disputes, losses, or damages from interactions with other users.</li>
    </ul>
</section>

<section>
    <h2>10. Changes to Terms</h2>
    <p>We may update these Terms occasionally. Users will be notified of significant changes. Continued use constitutes acceptance of updated terms.</p>
</section>

<section>
    <h2>11. Governing Law</h2>
    <p>These Terms are governed by Canadian law.</p>
</section>`;

  return (
    <Card variant="rounded">
      <div className="prose mx-auto py-4 dark:prose-invert sm:p-6">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </Card>
  );
};

export default TosPage;
